/**
 * Hook pour gérer les tokens (Twitch, Spotify)
 * @module admin/hooks/useTokens
 */

import { useState, useCallback } from 'react';
import {
  getTokenStatus,
  refreshToken as refreshTokenService,
} from '../services/maintenanceService';
import { getIntegrationStatus } from '../services/maintenanceService';

/**
 * Hook de gestion des tokens
 * @returns {Object} État et fonctions pour les tokens
 */
export const useTokens = () => {
  const [tokenStatus, setTokenStatus] = useState(null);
  const [maintenanceLoading, setMaintenanceLoading] = useState(false);
  const [maintenanceResult, setMaintenanceResult] = useState(null);
  const [maintenanceError, setMaintenanceError] = useState(null);

  /**
   * Récupère le statut des tokens
   */
  const fetchTokenStatus = useCallback(async () => {
    try {
      const data = await getTokenStatus();
      setTokenStatus(data.data);
    } catch (err) {
      console.error(
        'Erreur lors de la récupération du statut des tokens:',
        err
      );
    }
  }, []);

  /**
   * Rafraîchit un token
   * @param {string} service - 'twitch' ou 'spotify'
   */
  const handleRefreshToken = useCallback(async (service) => {
    setMaintenanceLoading(true);
    setMaintenanceResult(null);
    setMaintenanceError(null);

    try {
      const data = await refreshTokenService(service);
      setMaintenanceResult(data);
      await fetchTokenStatus();
      await getIntegrationStatus();
    } catch (err) {
      setMaintenanceError(err.message);
    } finally {
      setMaintenanceLoading(false);
    }
  }, [fetchTokenStatus]);

  return {
    tokenStatus,
    maintenanceLoading,
    maintenanceResult,
    maintenanceError,
    fetchTokenStatus,
    handleRefreshToken,
  };
};
